import { render, staticRenderFns } from "./ClientViewDetail.vue?vue&type=template&id=1c717fb2&scoped=true"
import script from "./ClientViewDetail.vue?vue&type=script&lang=js"
export * from "./ClientViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ClientViewDetail.vue?vue&type=style&index=0&id=1c717fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c717fb2",
  null
  
)

export default component.exports